<!--  -->
<template>
    <div class='container'>
        <div class="map_wrapper box box_v">
            <div id="studentmaps" class="map box_f1"></div>
        </div>
        <div class="infobox" id="infoboxid" v-if="showinfobox" :style="{top:infocsstop+'px',left:infocssleft+'px'}">
          <div class="infoboxtop">地球好111</div>
          <div class="infolistbox">
            <div class="infolist box" v-for="(item,index) in infolist">
              <div class="box ac"><span>华龙区中心小学</span></div>
              <div class="box box_v box_center"><span>幼升小</span><span>幼升小</span></div>
              <div class="box ac"><span>520人</span></div>
            </div>
          </div>
          <div class="closed iconfont icon-quxiao1" @click="closeinfobox"></div>
          <div class="bottomline box box_v ac">
            <span></span><span class="box_f1"></span>
          </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
var map = null
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
          showinfobox:false,
          infolist:[{},{},{},{}],
          infocssleft:0,
          infocsstop:0
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      closeinfobox(){
        this.showinfobox=false
      },
      overlayGroupclick(e){
        console.log(e)
        let lat=e.lnglat.lat
        let lon=e.lnglat.lng
        console.log(e.target.w.extData.id)
        this.infocsstop=e.originEvent.offsetY-302
        this.infocssleft=e.originEvent.offsetX-144
        this.showinfobox=true
      },
      initMap(){
          let that = this
          map = new AMap.Map('studentmaps', {
              zoom: 12,
              center:[115.041299,35.768234],
              mapStyle: "amap://styles/7048634155f3b6e2e1eaffe31697ebaf",
          });
          new AMap.DistrictSearch({
              subdistrict: 0,   //返回下一级行政区
              extensions: 'all',  //返回行政区边界坐标组等具体信息
              level: 'city'  //查询行政级别为 市center
          }).search("濮阳市", function (status, result) {
            console.log(result)
              console.log(result.districtList[0].center)
          });

          let list =[
            {path:[
                new AMap.LngLat(115.041299,35.761234),
                new AMap.LngLat(115.042399,35.763234),
                new AMap.LngLat(115.045499,35.77234),
                new AMap.LngLat(115.048499,35.768234)
            ]},
            {path:[
                new AMap.LngLat(115.011299,35.741234),
                new AMap.LngLat(115.012399,35.743234),
                new AMap.LngLat(115.015499,35.74634),
                new AMap.LngLat(115.018499,35.748234)
            ]},
            {path:[
                new AMap.LngLat(115.051299,35.731234),
                new AMap.LngLat(115.052399,35.733234),
                new AMap.LngLat(115.055499,35.73634),
                new AMap.LngLat(115.058499,35.738234)
            ]},
          ]
          let OverlayGroup=[]

          for(let i=0;i<list.length;i++){
              let key= new AMap.Polygon({
                path: list[i].path,
                fillColor: '#fff110', // 多边形填充颜色
                fillOpacity:0,
                extData:{id:i},
                borderWeight: 1, // 线条宽度，默认为 1
                strokeColor: '#fff110', // 线条颜色
            });
            key.setMap(map);
            key.on("click",that.overlayGroupclick)
            map.add(key);
          }


      }

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

        this.$nextTick(()=>{
            this.initMap()
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
        console.log('销毁地图')
        map && map.destroy();
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{width:100%;height:100%;position: relative;}
.map_wrapper{width:100%;height:100%;}
.map{width: 100%;height: 100%;}

.infobox{width: 288px;height: 258px;border-radius: 4px;box-shadow: 0 0 10px #fff100;
position: absolute;left: 100px;top: 200px;background: rgba(10, 34, 98, 0.7);}
.infoboxtop{height:34px;display: flex;display: -webkit-flex;align-items: center;font-size: 16px;font-weight: bold;color: #FFFFFF;margin-left: 10px;}
.infolistbox{width: 100%;padding-bottom: 10px;}
.infolist{width: 268px;height: 46px;background: #213B7F;margin: 0 auto;margin-top: 10px;}
.infolist:nth-child(1){margin-top: 0;}
.infolist div:nth-child(1){width:126px;height: 46px;margin-left: 20px;color: #FFFFFF;font-size: 14px;}
.infolist div:nth-child(2){width: 60px;height: 46px;color: #FFFFFF;font-size: 14px;}
.infolist div:nth-child(3){height: 46px;color: #FFFFFF;font-size: 14px;color: #F6FF00;font-size: 18px;font-weight: 400;}
.closed{font-size:20px;color: #FFFFFF;position: absolute;top: -22px;right:-18px;}
.bottomline{width: 10px;height: 47px;margin-left: 140px;}
.bottomline span:nth-child(1){width: 1px;height: 38px;background: #FFF100;opacity: 0.5;}
.bottomline span:nth-child(2){width: 9px;height: 9px;background: #FFF100;box-shadow: 0px 2px 6px 0px #FFF100;border-radius: 50%;}
</style>
